import './dashboard.css'
import * as React from 'react'
import DashboardContent from '../../components/dashboard-content/dashboard-content'

/**
 * Dashboard Component.
 * Represents the page for the dashboard.
 *
 * @returns {React.ReactElement} - Dashboard Component.
 */
const Dashboard = () => {
  return <DashboardContent />
}

export default Dashboard
